export const DefaultCommunity = {
  communityName: 'PYA Portal',
  communityLogo: '/logo.svg',
  communityLogoPublicId: '',
  communitySocialImage: '/logo.svg',
  primaryColor: '#0084FF',
  facebookLoginEnabled: false,
  googleLoginEnabled: false,
  githubLoginEnabled: false,
};
